var exports = {
  "og": "xfb577c5e--9c1c60--seller",
  "JM": "xfb577c5e--9c1c60--seller-title",
  "Mc": "xfb577c5e--9c1c60--seller-logo",
  "n9": "xfb577c5e--9c1c60--seller-info",
  "o4": "xfb577c5e--9c1c60--seller-name",
  "NU": "xfb577c5e--9c1c60--seller-label",
};

module.exports = exports;
